// api.js
import axios from "axios";

const API_TOKEN = process.env.REACT_APP_DATOCMS_READ_ONLY_API_TOKEN;
const API_URL = "https://graphql.datocms.com/";

export const fetchProjects = async () => {
  try {
    const response = await axios.post(
      API_URL,
      {
        query: `
          {
            work {
              all {
                id
                title
                video1 { url }
                video2 { url }
                credits
                description
                two
                show
                thumbnail {
                  id
                  url
                }
                gallery {
                  id
                  url
                  height
                  width
                }
              }
            }
          }
        `
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${API_TOKEN}`,
        },
      }
    );

    return response.data.data.work.all;
  } catch (error) {
    console.error("Error fetching projects:", error);
    return [];
  }
};
